import { useAppSelector } from 'reduxTyped'
import { billing } from 'common/billing'
import { Ability } from 'common/core/constants/Ability'
import { ChannelType } from 'common/core/constants/ChannelType'
import { useAbility } from 'common/core/hooks/useAbility'
import { ChannelStatus } from 'common/core/interfaces/channelStatuses'
import { getInstagramChannelStatus } from 'common/core/selectors/channelSelectors'
import { getCurrentAccountChannelOfIntent } from 'common/core/selectors/currentAccountSelectors'
import { getUserRole } from 'common/userRoles'
import { UserRoles } from 'common/userRoles/userRolesInterfaces'

export const useShowAITab = (includeChannelOfIntent = false) => {
  const userRole = useAppSelector(getUserRole)
  const aiAlwaysOnAbility = useAbility(Ability.AI_ALWAYS_ON)
  const igStatus = useAppSelector(getInstagramChannelStatus)
  const channelOfIntent = useAppSelector(getCurrentAccountChannelOfIntent)

  if (includeChannelOfIntent && channelOfIntent === ChannelType.INSTAGRAM) {
    return true
  }

  const hasRolePermission = [UserRoles.ADMIN, UserRoles.EDITOR].includes(userRole)

  return (
    hasRolePermission &&
    !aiAlwaysOnAbility.isBlocked &&
    ((!billing.isV3() && igStatus !== ChannelStatus.NONE) || billing.isV3())
  )
}
